module.exports = __webpack_public_path__ + "img/img2.b9eb3a56.jpg";